import React from "react";
import PractitionerInfo from "../admin/professionalPublicView";
import GiftShell from "./components/GiftShell";

// A medium's public profile opened from a VerySoul Gift (/profile-view/:id?from=gift),
// in a new tab: the same profile, without its paid "Book Here" — the recipient
// books through their gift instead.
export default function GiftProfileView() {
  // ?from=giver: a giver previewing who their gift could be used with.
  const giver = new URLSearchParams(window.location.search).get("from") === "giver";
  const backPath = giver ? "/give-a-gift" : "/redeem";

  const backToGift = (e) => {
    e.preventDefault();
    window.close();
    // Browsers only let a script close a tab it opened; otherwise go to the gift.
    setTimeout(() => {
      window.location.href = backPath;
    }, 150);
  };

  return (
    <GiftShell>
      <div className="vsr-gift-profile">
        <div className="vsr-gift-profile-banner">
          <span>{giver ? "You're previewing what your recipient could choose." : "You're viewing this medium from your VerySoul Gift."}</span>
          <a className="vsr-link" href={backPath} onClick={backToGift}>
            &larr; Back to your gift
          </a>
        </div>
        <PractitionerInfo view="public" giftMode={true} />
      </div>
    </GiftShell>
  );
}
